<template>
  <location-stock
    :loading="loading"
    :location="location"
  ></location-stock>
</template>

<script>
  // Components
  import LocationStock from '@/components/Common/Location/Stock'

  export default {
    props: {
      loading: Boolean,
      location: Object,
    },

    components: {
      LocationStock
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/Logistics/Locations/Stock.vue